import { render, staticRenderFns } from "./point-outline-picker.vue?vue&type=template&id=22be415c&"
import script from "./point-outline-picker.vue?vue&type=script&lang=js&"
export * from "./point-outline-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports